import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumBogofQuantityBasis implements BaseEnumType {
  private static allValues: EnumBogofQuantityBasis[] = []; // make sure this is top-most
  
  public static none = new EnumBogofQuantityBasis(0, "None", "enum_bogof_quantity_basis_none");
  public static units = new EnumBogofQuantityBasis(1, "Units", "enum_bogof_quantity_basis_units");
  public static volumeAs9Gs = new EnumBogofQuantityBasis(2, "VolumeAs9Gs", "enum_bogof_quantity_basis_volume_as9_gs");
  public static volumeAsLitres = new EnumBogofQuantityBasis(3, "VolumeAsLitres", "enum_bogof_quantity_basis_volume_as_litres");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumBogofQuantityBasis.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumBogofQuantityBasis.none; }
  public isUnits() { return this === EnumBogofQuantityBasis.units; }
  public isVolumeAs9Gs() { return this === EnumBogofQuantityBasis.volumeAs9Gs; }
  public isVolumeAsLitres() { return this === EnumBogofQuantityBasis.volumeAsLitres; }

  public static getValues(): readonly EnumBogofQuantityBasis[] {
    return EnumBogofQuantityBasis.allValues;
  }

  public static getValuesExcept0(): readonly EnumBogofQuantityBasis[] {
    return EnumBogofQuantityBasis.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumBogofQuantityBasis {
    const found = EnumBogofQuantityBasis.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumBogofQuantityBasis - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumBogofQuantityBasis): EnumBogofQuantityBasis {
    const found = name ? EnumBogofQuantityBasis.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumBogofQuantityBasis - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumBogofQuantityBasis>): boolean {
    return this.key === other?.key;
  }
}